<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import FilterBar from 'dashboard/components-next/filter-bar/FilterBar.vue';

// CRM-01h: a segunda linha do cabeçalho do quadro. Busca e uma pílula por filtro, no formato do
// HubSpot; o que se usa menos (prioridade, etiqueta, dias na etapa) mora em "Mais filtros" até
// ganhar valor. No celular, as pílulas ficam atrás do botão "Filtros".
// UI-FILTROS-01 (UF-12): a barra é a FilterBar padrão. Aqui fica só o que é do Kanban: os campos,
// as opções e os rótulos.
defineProps({
  modelValue: { type: Object, required: true },
});

const emit = defineEmits(['update:modelValue', 'reset']);

const { t } = useI18n();

const inboxes = useMapGetter('inboxes/getInboxes');
const teams = useMapGetter('teams/getTeams');
const agents = useMapGetter('agents/getAgents');
const labels = useMapGetter('labels/getLabels');

const STALE_DAYS = [3, 7, 14, 30];

const campos = computed(() => [
  {
    key: 'status',
    label: t('KANBAN.FILTERS.STATUS'),
    options: [
      { id: 'open', name: t('CHAT_LIST.CHAT_STATUS_FILTER_ITEMS.open.TEXT') },
      {
        id: 'pending',
        name: t('CHAT_LIST.CHAT_STATUS_FILTER_ITEMS.pending.TEXT'),
      },
      {
        id: 'snoozed',
        name: t('CHAT_LIST.CHAT_STATUS_FILTER_ITEMS.snoozed.TEXT'),
      },
      {
        id: 'resolved',
        name: t('CHAT_LIST.CHAT_STATUS_FILTER_ITEMS.resolved.TEXT'),
      },
    ],
  },
  {
    key: 'inbox_ids',
    label: t('KANBAN.FILTERS.INBOX'),
    options: inboxes.value.map(({ id, name }) => ({ id, name })),
  },
  {
    key: 'team_id',
    label: t('KANBAN.FILTERS.TEAM'),
    options: teams.value.map(({ id, name }) => ({ id, name })),
  },
  {
    key: 'assignee_id',
    label: t('KANBAN.FILTERS.ASSIGNEE'),
    options: agents.value.map(({ id, name }) => ({ id, name })),
  },
  {
    key: 'priority',
    label: t('KANBAN.FILTERS.PRIORITY'),
    extra: true,
    options: [
      { id: 'urgent', name: t('CONVERSATION.PRIORITY.OPTIONS.URGENT') },
      { id: 'high', name: t('CONVERSATION.PRIORITY.OPTIONS.HIGH') },
      { id: 'medium', name: t('CONVERSATION.PRIORITY.OPTIONS.MEDIUM') },
      { id: 'low', name: t('CONVERSATION.PRIORITY.OPTIONS.LOW') },
    ],
  },
  {
    key: 'labels',
    label: t('KANBAN.FILTERS.LABEL'),
    extra: true,
    options: labels.value.map(({ title }) => ({ id: title, name: title })),
  },
  // Os filtros guardam listas, menos "dias na etapa", que é um número só.
  {
    key: 'stale_days',
    label: t('KANBAN.FILTERS.STALE'),
    extra: true,
    single: true,
    scalar: true,
    options: STALE_DAYS.map(days => ({
      id: days,
      name: t('KANBAN.FILTERS.STALE_OPTION', { days }),
    })),
  },
]);

const busca = computed(() => ({ placeholder: t('KANBAN.FILTERS.SEARCH') }));
</script>

<template>
  <FilterBar
    :model-value="modelValue"
    :fields="campos"
    :search="busca"
    @update:model-value="valor => emit('update:modelValue', valor)"
    @reset="emit('reset')"
  />
</template>
